export default {
    news: {
        title: "Tin tức",
        categoryAria: "Danh mục tin",
        tabs: {
            all: "Tất cả",
            game: "Trò chơi",
            skillChange: "Cập nhật",
            box: "JX3BOX",
        },
    },
    followus: {
        title: "Theo dõi",
        bilibili: {
            name: "Bilibili",
            desc: "@JX3BOX",
            alt: "Bilibili",
        },
        weibo: {
            name: "Weibo",
            desc: "@JX3BOX",
            alt: "Weibo",
        },
        douyin: {
            name: "Douyin",
            desc: "@JX3BOX",
            alt: "Douyin",
        },
        wechat: {
            name: "WeChat OA",
            desc: "@JX3BOX",
            alt: "WeChat Official Account",
            qrcodeAlt: "Mã QR",
            qrcodeImageAlt: "Mã QR WeChat",
        },
    },
    feedback: {
        title: "Góp ý",
        subtitle: "Feedback Center",
    },
    posts: {
        categoryAria: "Danh mục nội dung",
        more: "Xem thêm >>",
        tabs: {
            all: "Tất cả",
            works: "Tác phẩm",
            community: "Bài viết",
        },
        empty: "Chưa có nội dung",
        anonymous: "Ẩn danh",
        noTitle: "Không tiêu đề",
        discussion: "Thảo luận",
        noContent: "Không có nội dung",
        picture: "[Ảnh]",
        reply: "Trả lời",
    },
    box: {
        title: "Ma trận JX3BOX",
        customize: "Tùy chỉnh",
        save: "Lưu bố cục",
        tooltip: {
            breakLine: "Xuống dòng",
            hide: "Ẩn",
            show: "Hiện",
        },
        reset: "Đặt lại",
        resync: "Đồng bộ lại",
        notify: {
            successTitle: "Thành công",
            syncToLocal: "Đã đồng bộ dữ liệu về máy",
            infoTitle: "Thông tin",
            noRemote: "Không có cấu hình đã lưu trên máy chủ",
            resetConfirmTitle: "Xác nhận",
            resetConfirmText: "Đặt lại về mặc định?",
            resetConfirmBtn: "OK",
            resetSuccess: "Đã đặt lại về mặc định",
        },
    },
    jx3code: {
        title: "Mã hôm nay",
        copySuccess: "Đã sao chép",
    },
    activity: {
        subtitle: "Timeline",
        title: "Sự kiện",
        month: "Tháng {month}",
        empty: "Chưa có lịch",
        defaultName: "Sự kiện chưa đặt tên",
        defaultType: "Sự kiện",
    },
    joke: {
        title: "Câu nói hôm nay",
        anonymous: "Ẩn danh",
        defaultContent:
            "Sư phụ hỏi vì sao cấp 110 rồi mà vẫn chưa gặp người sống. Tôi nhìn lãnh địa bang hội trống vắng và rơi hai dòng lệ.",
    },
    world: {
        bulletin: "Bản tin giang hồ",
        entry: "Vào trung tâm tình báo",
        serversTitle: "Tình trạng máy chủ",
        chooseServer: "Chọn máy chủ",
        state: {
            open: "Mượt",
            busy: "Bận",
            full: "Quá tải",
            close: "Bảo trì",
            unknown: "Không rõ",
        },
        report: {
            baizhanMap: "Bản đồ Bách Chiến",
            celebrity: "Danh vọng",
            horse: "Tin bắt ngựa",
            pet: "Thú cưng may mắn",
            reputation: "Danh vọng gia viên",
            meirentu: "Mỹ nhân đồ",
        },
        celebrity: {
            time: "Thời gian",
            place: "Địa điểm",
            stage: "Giai đoạn",
            specialEvent: "Sự kiện đặc biệt · ",
            titleSuffix: {
                hxxm: "河西瀚漠",
                ylc: "伊丽川",
            },
            types: {
                qiongyew: "穹野卫",
                pifeng: "披风会",
                yuncong: "云从社",
                chutian: "楚天社",
            },
        },
        meirentu: {
            label: "Mỹ nhân đồ · ",
            todayNo: "Hôm nay không có tranh",
            week: {
                sun: "CN",
                mon: "T2",
                tue: "T3",
                wed: "T4",
                thu: "T5",
                fri: "T6",
                sat: "T7",
            },
        },
        baizhan: {
            divider: "Bách Chiến",
            detail: "Chi tiết",
            mapPreview: "Xem bản đồ",
        },
        luckyPet: {
            divider: "Thú cưng",
        },
        reputation: {
            divider: "Danh vọng gia viên",
        },
        horse: {
            notRefreshed: "Chưa làm mới trong CD này",
        },
    },
    importantMsg: {
        title: "Thông báo quan trọng",
        confirm: "Đã hiểu",
    },
};

